export default __webpack_public_path__ + "static/media/icon_pp_language.ee08a5c0.svg";